import { Component, inject, input, OnInit } from '@angular/core';
import { ParameterService } from '../../provider/parameter.service';

declare const amazon: any;

@Component({
  selector: 'lib-frontend-amazonpay-starter',
  standalone: true,
  imports: [],
  templateUrl: './amazonpay-starter.html',
  styleUrl: './amazonpay-starter.css',
})
export class AmazonpayStarter implements OnInit {
  data = input({} as any);
  private readonly parameterService = inject(ParameterService);

  ngOnInit(): void {
    this.loadAmazonCheckoutScript();
  }

  loadAmazonCheckoutScript() {
    const myScriptElement = document.createElement('script');
    myScriptElement.src = 'https://static-eu.payments-amazon.com/checkout.js';
    myScriptElement.type = 'text/javascript';
    myScriptElement.async = true;

    myScriptElement.onload = () => {
      this.initAmazonPayButton();
    };

    document.body.appendChild(myScriptElement);
  }

  getAmount(): number {
    return this.parameterService.getOpenAmount();
  }

  hash(str: string) {
    const utf8 = new TextEncoder().encode(str);
    return crypto.subtle.digest('SHA-256', utf8).then((hashBuffer) => {
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray
        .map((bytes) => bytes.toString(16).padStart(2, '0'))
        .join('');
      return hashHex;
    });
  }

  private getCheckoutSessionConfig() {
    return {
      payloadJSON: this.data().payload.replaceAll('\\/', '/'),
      signature: this.data().signature,
      algorithm: this.data().algorithm,
    };
  }

  private getButtonContent() {
    return {
      // set checkout environment
      merchantId: this.data().merchantId,
      publicKeyId: this.data().publicKeyId,
      ledgerCurrency: 'EUR',
      // customize the buyer experience
      checkoutLanguage: 'de_DE',
      productType: 'PayOnly',
      placement: 'Checkout',
      buttonColor: 'Gold',
      estimatedOrderAmount: {
        amount: this.parameterService.getOpenAmount(),
        currencyCode: 'EUR',
      },
      // configure Create Checkout Session request
      createCheckoutSessionConfig: this.getCheckoutSessionConfig(),
    };
  }

  private initAmazonPayButton() {
    amazon.Pay.renderButton('#AmazonPayButton', this.getButtonContent());
  }
}
